export default {
    "New": "#F44336",
    "Planned": "#2196F3",
    "Started": "#FF9800",
    "Transporting": "#9C27B0",
    "Ready": "#4CAF50",
    "Deferred": "#000000",

    // TODO move waybill states elsewhere
    "Missing": "#F44336",
    "Preparing": "#FF9800",
    "InTransit": "#9C27B0",
    "Complete": "#4CAF50",
    "Draft": "#999999",
};
